import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings';
import { StatsigSessionReplayPlugin } from '@statsig/session-replay';
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics';
import { APP_ENV } from '@my/config'
import { LoadingView } from 'app/components/utilities';

export const StatsigInitProvider = ({user, children}) => {
  const { client } = useClientAsyncInit(
    "client-7ccvhSdB1hL7T5cmW9gxh76OVl8dz3JnPBJIiYt3I0w",
    { userID: user.id }, 
    { 
      environment: { tier: APP_ENV.TZA_ENV },
      plugins: [ new StatsigAutoCapturePlugin(), new StatsigSessionReplayPlugin() ] 
    },
  );
  return <StatsigProvider client={client} loadingComponent={<LoadingView />}>
    {children}
  </StatsigProvider> 
}